import classNames from 'clsx'
import { bool, func } from 'prop-types'
import { type FunctionComponent } from 'react'

import { CategoryListItemType } from 'shared/experiments/components/NewSerp/types'
import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import IconCaretDown from 'views/components/atoms/Icon/IconCaretDown'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'

const CategoryListItem: FunctionComponent<ComponentProps> = ({
  item: { label, count, level, hideCount, isRefined },
  onClick,
  isLast,
}) => {
  const className = classNames(
    `m-CategoryList--item m-CategoryList--item-${level}`,
    {
      'u-margin-xx-small--bottom': !isLast,
      'u-font-weight--bold': isRefined,
    }
  )

  return (
    <li className={className}>
      <ButtonAsLink name={`category-list-${label}`} left onClick={onClick}>
        {isRefined ? (
          <IconCaretDown size="small" />
        ) : (
          <IconCaretRight size="small" />
        )}
        {label}
        <span suppressHydrationWarning>
          {!hideCount && <>&nbsp;({count})</>}
        </span>
      </ButtonAsLink>
    </li>
  )
}

const propTypes = {
  item: CategoryListItemType.isRequired,
  onClick: func.isRequired,
  isLast: bool.isRequired,
}

const defaultProps = {}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default CategoryListItem
